import { useEffect } from 'react';
import flagTracker from '../utils/tracking/flagTracker';

function useTrackFlags(flags) {
  const keys = Object.keys(flags);

  useEffect(() => {
    if (keys.length > 0) {
      keys.forEach((key) => {
        flagTracker(flags[key]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useTrackFlags;
